const routes = {
    path: 'exportacaoxls',
    name: 'MapaParceiros_exportacaoxls',
    component: () => import('./ExportarXls.vue'),
    meta: {
        rules: ['MAPAPARC-PES-00'],
    },
};

export default routes;